export default __webpack_public_path__ + "static/media/WhatsApp Image 2021-11-07 at 8.53.09 PM.7c2d29cd.jpeg";